import {can} from '../api/permissions'

export function folderManagementActions(roles:string[],systemOwned=false,root=false){
  if(systemOwned)return[]
  return [
    {id:'create',label:root?'新建根目录':'新建子目录',icon:'plus',permission:'folder.create'},
    ...(root?[]:[{id:'rename',label:'重命名',icon:'edit',permission:'folder.update'},{id:'move',label:'移动到…',icon:'move',permission:'folder.move'},{id:'delete',label:'删除空目录',icon:'trash',permission:'folder.delete'}]),
  ].filter(item=>can(roles,item.permission))
}

export function folderMenuPosition(anchor:{left:number;top:number;bottom:number},viewport:{width:number;height:number},menu:{width:number;height:number}){
  const left=Math.max(8,Math.min(anchor.left,viewport.width-menu.width-8))
  const below=anchor.bottom+4
  const top=Math.max(8,Math.min(below+menu.height<=viewport.height-8?below:anchor.top-menu.height-4,viewport.height-menu.height-8))
  return{left,top}
}
